import { api } from '@/api/api-client.config.ts';
import { useQuery } from '@tanstack/react-query';
import { LeagueType } from '@/@types/api.types.ts';

const getFriendLeagues = (): Promise<{ leagues: LeagueType[] }> =>
  api.get(`/admin/leagues/friends?limit=20`);

export const useGetFriendLeaguesQuery = () => {
  return useQuery({
    queryKey: ['getFriendLeagues'],
    queryFn: getFriendLeagues,
    select: (data) => data.leagues,
  });
};
